<template>
	<v-flex xs12 sm4 md4 mr-4 mb-5>
		<v-card color="white" class="blue-grey--text elevation-0">
			<v-container fluid grid-list-lg>
				<v-layout row>
					<v-flex xs7>
						<div>
							<div class="headline mb-3"><b>{{ data.name }}</b></div>

							<div class="mb-1" v-for="item in data.list" :key="item.id"><b>{{ item.name }}: &nbsp;</b>{{ item.value }}</div>
						</div>
					</v-flex>
					<v-flex xs5 v-if="data.img">
						<v-img
							:src="data.img"
							height="325px"
							contain
						></v-img>
					</v-flex>
				</v-layout>
			</v-container>
		</v-card>
		<!-- <v-card-actions>
			<v-spacer></v-spacer>
			<v-btn flat color="blue-grey darken-4" @click.native="person.show = !person.show">View personal data</v-btn>
		
		</v-card-actions>
		<v-slide-y-transition>
			<v-card-text v-show="person.show">
				<div class="text-lg-right"><b>DOB: </b>{{ person.dob }}</div>
				<div class="text-lg-right"><b>Registered: </b>{{ person.registered }}</div>
			</v-card-text>
		</v-slide-y-transition> -->
	</v-flex>
</template>

<script>
export default {
	name: 'CardTemplate',
	props: ['data'],
	data () {
		return {
			lng: this.$store.getters.ACTIVE_LANGUAGE,
		}
	},
	computed: {
		translates () {
			return this.$store.getters.TRANSLATES;
		}
	},
}
</script>

<style lang="scss">
</style>
